module.exports = __webpack_public_path__ + "img/gift.854e0fa5.svg";